<template>
  <div class="main-claims-settlement">
    <div class="claims-settlement-sum">
      <el-row style="margin-top: 50px">
        <el-col :span="6">{{$lang('运单票数')}}</el-col>
        <el-col :span="6">{{$lang('已返款票数')}}</el-col>
        <el-col :span="6">{{$lang('返款金额')}}</el-col>
        <el-col :span="6">{{$lang('未返款票数')}}</el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="6">{{totalResult.waybillNum || 0}}</el-col>
        <el-col :span="6">{{totalResult.returnNum || 0}}</el-col>
        <el-col :span="6">{{totalResult.returnValue || 0.00}}</el-col>
        <el-col :span="6">{{totalResult.notReturnNum || 0}}</el-col>
      </el-row>
    </div>
    <div class="form-claims-settlement">
      <el-form :inline="true" :model="searchParam" class="demo-form-inline">
        <el-form-item prop="dateType">
          <el-select v-model="searchParam.dateType" class="order-number-select">
            <el-option :label="$lang('登记时间')" value="2"></el-option>
            <el-option :label="$lang('退款时间')" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="date" style="margin-left: -15px;">
          <el-date-picker
              :clearable="false"
              v-model="searchParam.date"
              type="daterange"
              :range-separator="$lang('至')"
              :start-placeholder="$lang('开始日期')"
              :end-placeholder="$lang('结束日期')"
              class="commonSize"
              @change="selectDate"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$lang('运单号')" prop="waybillNo" v-show="activeName ==='detail'" style="margin-left: 15px;">
          <base-input-tag
              v-model="searchParam.waybillNo"
              :placeholder="$lang('最多可查100条')"
              clearBtnVisible
              addTagOnBlur
              ref="orderNumberRef"
              class="cms-input-tag"
          >
          </base-input-tag>
        </el-form-item>
        <el-form-item prop="isReturn"  :label="$lang('是否退款')" v-show="activeName ==='detail'">
          <el-select v-model="searchParam.isReturn" class="order-number-select" clearable>
            <el-option :label="$lang('是')" value="1"></el-option>
            <el-option :label="$lang('否')" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="display: flex;justify-content: flex-end;">
          <el-button type="primary" :loading="loading" icon="el-icon-search" @click="onSubmit">{{$lang('查询')}}</el-button>
          <el-button @click="reset" icon="el-icon-delete">{{$lang('清空')}}</el-button>
          <el-button @click="exportRecord" :loading="loading" icon="el-icon-download">{{$lang('导出')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-claims-settlement">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$lang('汇总')" name="sum">
          <JmsTableScroll
              ref="sumTable"
              class="tableClass"
              :option="sumListOpt"
              :data="sumTableData"
              :page="page"
              :table-loading="loading"
              @size-change="sizeChange"
              @current-change="currentChange"
          >
          </JmsTableScroll>
        </el-tab-pane>
        <el-tab-pane :label="$lang('明细')" name="detail">
          <JmsTableScroll
              :option="detailListOpt"
              :data="detailTableData"
              :page="page"
              :table-loading="loading"
              @size-change="sizeChange"
              @current-change="currentChange"
          >
          </JmsTableScroll>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { commonFun } from '@utils/common'
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import { pageClaimsSettlementSum, pageClaimsSettlementDetail, exportAsync } from '@api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'

export default {
  name: 'ClaimsSettlement',
  components: {
    JmsTableScroll,
  },
  props: {
    tabPosition: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeName: 'sum',
      loading: false,
      searchParam: {
        date: [],
        dateType: '2',
      },
      totalResult: {
        waybillNum: 0,
        returnNum: 0,
        returnValue: 0.00,
        notReturnNum: 0,
      },
      page: {
        // 分页配置
        current: 1,
        size: 50,
        total: 0,
        pageSizes: [50, 100, 200, 500],
      },
      sumTableData: [],
      detailTableData: [],
      pickerOptions: {
        disabledDate(time) {
          const space = 90 * 24 * 3600 * 1000
          const minTime = new Date().getTime() - space
          const maxTime = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
          return time.getTime() < minTime || time.getTime() > maxTime
        },
      },
    }
  },
  watch: {
    tabPosition(val) {
      if (val && this.$refs.sumTable) {
        this.$refs.sumTable.$refs.table.doLayout()
      }
    },
  },
  methods: {
    handleClick() {
      this.onSubmit()
    },
    validateParam() {
      console.log(this.searchParam)
      const { beginDate, endDate } = this.searchParam
      const space = 31 * 24 * 3600 * 1000
      const startTimeLong = new Date(beginDate).getTime()
      const endTimeLong = new Date(endDate).getTime()
      if (endTimeLong - startTimeLong > space) {
        return this.$message.error(this.$lang('开始时间与结束时间之差不能大于31天'))
      }
      // 处理运单编号
      if (this.searchParam.orderNumber && this.searchParam.orderNumber.length !== 0) {
        if (this.searchParam.orderNumber.length > 100) {
          return this.$message.warning(this.$lang('单号请勿超过100条'))
        }
      }
    },
    async exportRecord() {
      if (this.validateParam()) {
        return
      }
      this.loading = true
      if (this.activeName === 'sum') {
        this.searchParam.fileCode = '5'
      }
      if (this.activeName === 'detail') {
        this.searchParam.fileCode = '6'
      }
      const { code, data, msg } = await exportAsync(this.searchParam)
      this.loading = false
      if (code === RESPONSE_SUCCESS && data) {
        this.$message.success(this.$lang('导出成功，请到下载中心查看'))
      } else {
        return this.$message.error(this.$lang(msg))
      }
    },
    async onSubmit() {
      if (this.validateParam()) {
        return
      }
      this.loading = true
      this.searchParam.current = this.page.current
      this.searchParam.size = this.page.size
      if (this.activeName === 'sum') {
        const { code, data, msg } = await pageClaimsSettlementSum(this.searchParam)
        this.loading = false
        if (code === RESPONSE_SUCCESS) {
          this.sumTableData = data.records
          this.totalResult = data.totalResult
          this.page.current = data.current
          this.page.total = data.total
          this.$nextTick(() => {
            this.$refs.sumTable.$refs.table.doLayout()
          })
        } else {
          return this.$message.error(this.$lang(msg))
        }
      }
      if (this.activeName === 'detail') {
        const { code, data, msg } = await pageClaimsSettlementDetail(this.searchParam)
        this.loading = false
        if (code === RESPONSE_SUCCESS) {
          this.detailTableData = data.records
          if (this.detailTableData && this.detailTableData.length > 0) {
            for (let i = 0; i < this.detailTableData.length; i++) {
              this.detailTableData[i].isReturn = this.$lang(this.detailTableData[i].isReturn)
            }
          }
          this.page.current = data.current
          this.page.total = data.total
        } else {
          this.$message.error(this.$lang(msg))
        }
      }
    },
    reset() {
      this.setDefaultDate()
      this.searchParam.dateType = '2'
      this.searchParam.waybillNo = []
      this.searchParam.isReturn = ''
    },
    // 选择日期
    selectDate() {
      if (this.searchParam.date) {
        const [start = '', end = ''] = this.searchParam.date
        this.searchParam.beginDate = start
        this.searchParam.endDate = end
      }
    },
    setDefaultDate() {
      const today = new Date()
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      const firstDay = commonFun.formatDate(firstDayOfMonth)
      this.searchParam.date = [firstDay, commonFun.formatDate(today)]
      this.selectDate()
    },
    // 选择分页条数
    sizeChange(val) {
      this.page.current = 1
      this.page.size = val
      this.onSubmit()
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.onSubmit()
    },
  },
  created() {
    this.setDefaultDate()
    this.onSubmit()
  },
  computed: {
    sumListOpt() {
      return {
        tableHeight: '400',
        border: true,
        selection: false,
        menu: false,
        menuWidth: 150,
        rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '日期',
            prop: 'dateCode',
          },
          {
            label: '运单票数',
            prop: 'waybillNum',
          },
          {
            label: '已返款票数',
            prop: 'returnNum',
          },
          {
            label: '未返款票数',
            prop: 'notReturnNum',
          },
          {
            label: '返款金额',
            prop: 'returnValue',
          },
        ],
      }
    },
    detailListOpt() {
      return {
        tableHeight: '400',
        border: true,
        selection: false,
        menu: false,
        menuWidth: 150,
        rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '登记时间',
            prop: 'djTime',
          },
          {
            label: '运单号',
            prop: 'waybillNo',
          },
          {
            label: '物品名称',
            prop: 'goodsName',
          },
          {
            label: '开单件数',
            prop: 'quanty',
          },
          {
            label: '货损件数',
            prop: 'badQuanty',
          },
          {
            label: '索赔金额',
            prop: 'claimMoney',
          },
          {
            label: '物品价值',
            prop: 'goodsValue',
          },
          {
            label: '计费重量',
            prop: 'chargeWeight',
          },
          {
            label: '返款金额',
            prop: 'returnValue',
          },
          {
            label: '是否退款',
            prop: 'isReturn',
          },
          {
            label: '收款人',
            prop: 'paymentName',
          },
          {
            label: '收款银行',
            prop: 'paymentBank',
          },
          {
            label: '收款账户',
            prop: 'paymentAccount',
          },
          {
            label: '开户城市',
            prop: 'paymentCity',
          },
          {
            label: '保价金额',
            prop: 'insuredValue',
          },
          {
            label: '退款时间',
            prop: 'returnTime',
          },
        ],
      }
    },
  },
}
</script>

<style scoped>
.form-claims-settlement{
  margin-left: 50px;
  margin-top: 20px;
}
.claims-settlement-sum{
  border: 1px solid black;
  border-radius: 20px;
  width: 90%;
  height: 150px;
  text-align: center;
  margin-left: 50px;
}
.main-claims-settlement{
  font-weight: 500;
  color: #666;
}
.order-number-select >>> .el-input{
  width: 100px !important;
}
.table-claims-settlement{
  margin-left: 50px;
}
</style>
